import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppContent from './Appcontent';

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;